import React, { useState } from 'react';
import axios from 'axios';  // Axios'u dahil ediyoruz
import { Button, Box } from "@mui/material";

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [loginType, setLoginType] = useState("user"); // Seçilen login tipi

    // Şifre sıfırlama işlemini başlatan fonksiyon
    const handleSubmit = async () => {
        try {
            // Veriyi göndermek için API isteği
            const response = await axios.post('https://kariyer.biyomed.net/api/register/forgotPassword', {
                email,
                loginType,
            });

            // Başarılı dönüş alındığında
            alert(response.data.message);  // Mesajı kullanıcıya göster

        } catch (err) {
            // Hata durumunda hata mesajını set ediyoruz
            setError(err.response ? err.response.data.message : 'Bir hata oluştu');
        }
    };

    return (
        <div>
            <div className="jp_tittle_main_wrapper">
                <div className="jp_tittle_img_overlay" />
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="jp_tittle_heading_wrapper">
                                <div className="jp_tittle_heading">
                                    <h2>Şifremi unuttum</h2>
                                </div>
                                <div className="jp_tittle_breadcrumb_main_wrapper">
                                    <div className="jp_tittle_breadcrumb_wrapper">
                                        <ul>
                                            <li>
                                                <a href="/">Anasayfa</a> <i className="fa fa-angle-right" />
                                            </li>
                                            <li>Şifremi unuttum</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* login Kismi */}
            <div className="login_section">
                <div className="login_form_wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8 col-md-offset-2">
                                <h1>Şifremi unuttum</h1>
                                <div className="login_wrapper">
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: 3,
                                            mb: 3
                                        }}
                                    >
                                        <Button
                                            variant={loginType === "user" ? "contained" : "outlined"}
                                            onClick={() => setLoginType("user")}
                                            sx={{
                                                width: 250,
                                                height: 50,
                                                backgroundColor: loginType === "user" ? "#23c0e9" : "#fff",
                                                color: loginType === "user" ? "#fff" : "#23c0e9",
                                                borderColor: "#23c0e9",
                                                "&:hover": {
                                                    backgroundColor: loginType === "user" ? "#a1eafd" : "#f5f5f5",
                                                },
                                            }}
                                        >
                                            KİŞİ Hesabı
                                        </Button>
                                        <Button
                                            variant={loginType === "company" ? "contained" : "outlined"}
                                            onClick={() => setLoginType("company")}
                                            sx={{
                                                width: 250,
                                                height: 50,
                                                backgroundColor: loginType === "company" ? "#23c0e9" : "#fff",
                                                color: loginType === "company" ? "#fff" : "#23c0e9",
                                                borderColor: "#23c0e9",
                                                "&:hover": {
                                                    backgroundColor: loginType === "company" ? "#a1eafd" : "#f5f5f5",
                                                },
                                            }}
                                        >
                                            Firma/Sağlık Kuruluşu Hesabı
                                        </Button>
                                    </Box>
                                    <div className="formsix-pos">
                                        <div className="form-group i-email">
                                            <input
                                                type="email"
                                                className="form-control"
                                                required=""
                                                id="email2"
                                                placeholder={loginType === "user" ? "Kişi Hesabı E-postası giriniz" :  "Firma/Sağlık Kuruluşu Hesabı E-postası giriniz" }
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)} // e-posta input'unu state ile bağladık
                                            />
                                        </div>
                                    </div>
                                    {error && <div style={{ color: 'red' }}>{error}</div>} {/* Hata mesajı */}
                                    <div className="login_btn_wrapper">
                                        <button
                                            className="btn btn-primary login_btn"
                                            onClick={handleSubmit}  // Formu gönder
                                        >
                                            Şİfre sıfırlama
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
